import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import FileGroupingExportFileSpecLookup from '../Models/Lookups/FileGroupingExportFileSpecLookup';

export default class ManageFileGroupingFileSpecExportConfigurationComponentVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
       public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
       public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
       public exportFileGroupingFileSpecApiClient = AppService.get(Types.ApiClients.FileGroupingExportFileSpecApiClient),
       public exportFileSpecApiClient = AppService.get(Types.ApiClients.StaticExportFileSpecApiClient)) {

        super(taskRunner);
        this.makeObservable();
    }
    public managedFileGroupingExportFileSpec = new FileGroupingExportFileSpecLookup();
    public isFieldReadOnlyInd: boolean = false;

    public async initialise() {

    }
}